/*!
* zeynepjs v2.2.0
* A light-weight multi-level jQuery side menu plugin.
* It's fully customizable and is compatible with modern browsers such as Google Chrome, Mozilla Firefox, Safari, Edge and Internet Explorer
* MIT License
* by Huseyin ELMAS
*/
(function ($, pluginName) {
  var defaults = {
    htmlClass: true
  }

  function Plugin (element, options) {
    this.element = element
    this.eventController = eventController
    this.options = $.extend({}, defaults, options)
    this.options.initialized = false

    this.init()
  }

  Plugin.prototype.init = function () {
    var zeynep = this.element
    var options = this.options
    var eventController = this.eventController.bind(this)

    // exit if already initialized
    if (options.initialized === true) return

    eventController('loading')

    // handle subMenu links/triggers click events
    zeynep.find('[data-submenu]').on('click', function (event) {
      event.preventDefault()

      var self = $(this)
      var subMenuId = self.attr('data-submenu')
      var subMenuEl = $('#' + subMenuId)

      // if subMenu not found, do nothing
      if (!subMenuEl.length) return

      var eventDetails = {
        subMenu: true,
        menuId: subMenuId
      }

      eventController('opening', eventDetails)

      // open the subMenu
      zeynep.find('.submenu.current').removeClass('current')
      subMenuEl.addClass('opened current')
      !zeynep.hasClass('submenu-opened') && zeynep.addClass('submenu-opened')

      // scroll to top before submenu transition
      zeynep[0].scrollTo({ top: 0 })

      eventController('opened', eventDetails)
    })

    // handle subMenu closers click events
    zeynep.find('[data-submenu-close]').on('click', function (event) {
      event.preventDefault()

      var self = $(this)
      var subMenuId = self.attr('data-submenu-close')
      var subMenuEl = $('#' + subMenuId)

      // if subMenu not found, do nothing
      if (!subMenuEl.length) return

      var eventDetails = {
        subMenu: true,
        menuId: subMenuId
      }

      eventController('closing', eventDetails)

      // close subMenu
      subMenuEl.removeClass('opened current')
      zeynep.find('.submenu.opened').last().addClass('current')
      !zeynep.find('.submenu.opened').length && zeynep.removeClass('submenu-opened')

      // scroll to top between submenu transitions
      subMenuEl[0].scrollTo({ top: 0 })

      eventController('closed', eventDetails)
    })

    eventController('load')

    // zeynepjs successfully initialized
    this.options.htmlClass && !$('html').hasClass('zeynep-initialized') && $('html').addClass('zeynep-initialized')

    options.initialized = true
  }

  Plugin.prototype.open = function () {
    this.eventController(
      'opening',
      { subMenu: false }
    )

    // zeynepjs menu is opened
    this.element.addClass('opened')
    this.options.htmlClass && $('html').addClass('zeynep-opened')

    this.eventController(
      'opened',
      { subMenu: false }
    )
  }

  Plugin.prototype.close = function (disableEvent) {
    !disableEvent && this.eventController('closing', { subMenu: false })

    // zeynepjs menu is opened
    this.element.removeClass('opened')
    this.options.htmlClass && $('html').removeClass('zeynep-opened')

    !disableEvent && this.eventController('closed', { subMenu: false })
  }

  Plugin.prototype.destroy = function () {
    this.eventController('destroying')

    // close the menu without firing any event
    this.close(true)

    // close submenus
    this.element.find('.submenu.opened').removeClass('opened')

    // clear/remove the instance on the element
    this.element.removeData(pluginName)

    this.eventController('destroyed')

    // reset options
    this.options = defaults

    this.options.htmlClass && $('html').removeClass('zeynep-initialized')

    delete this.element
    delete this.options
    delete this.eventController
  }

  Plugin.prototype.on = function (name, handler) {
    eventBinder.call(this, name, handler)
  }

  var eventController = function (type, details) {
    if (!this.options[type]) return
    if (typeof this.options[type] !== 'function') throw Error('event handler must be a function: ' + type)

    // call the event
    this.options[type].call(this, this.element, this.options, details)
  }

  var getInstance = function (element, options) {
    var instance = null

    if (!element.data(pluginName)) {
      // zeynepjs is not initialized for the element
      // crceate a new instance
      instance = new Plugin(element, options || {})

      // put the instance on element
      element.data(pluginName, instance)
    } else {
      // return the already initialized instance
      instance = element.data(pluginName)
    }

    return instance
  }

  var eventBinder = function (name, handler) {
    if (typeof name !== 'string') throw Error('event name is expected to be a string but got: ' + typeof name)
    if (typeof handler !== 'function') throw Error('event handler is not a function for: ' + name)

    // update options
    this.options[name] = handler
  }

  // a really lightweight plugin wrapper around the constructor
  // preventing against multiple instantiations
  $.fn[pluginName] = function (options) {
    // get a zeynepjs instance
    var instance = getInstance($(this[0]), options)

    return instance
  }
})(window.jQuery || window.cash, 'zeynep')




$(function() {
        // init zeynepjs side menu
        var zeynep = $('.drawer__inner').zeynep({
          opened: function () {
            // log
            //console.log('the side menu opened')
          },
          closed: function () {
            // log
            //console.log('the side menu closed')
          }
        })

        // dynamically bind 'closing' event
        zeynep.on('closing', function () {
          // log
          //console.log('this event is dynamically binded')
        })

        // handle zeynepjs overlay click
        $('.zeynep-overlay').on('click', function () {
          zeynep.close()
        })

      })












$(document).ready(function() {

	jQuery('body').on('click', '#checkoutbutton', function(e) {
    jQuery('#mobilecheckoutbutton').click();
          });

function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

jQuery( document ).ready( function() {
	window.addEventListener('scroll', function(e) {
		if( isOnScreen( jQuery( '.customstyleadvanced-content-page-1-3' ) ) ) { /* Pass element id/class you want to check */
			
//setTimeout(function() {

          
	const counters = document.querySelectorAll('.value');
	const speed = 6000;
	counters.forEach( counter => {
		const animate = () => {
			const value = +counter.getAttribute('akhi');
			const data = +counter.innerText;
			const time = value / speed;
			if(data < value) {
				counter.innerText = Math.ceil(data + time).toLocaleString();
				setTimeout(animate, 1);
			}else{
				counter.innerText = value.toLocaleString();
			} 
		}
		animate();
	});

//}, 700);

          
 		}	
	});
});




  

  


  jQuery('body').on('click', '#contactModalCall', function(e) {   
      e.preventDefault();
      jQuery('#popupcontactform').modal()
  });


    jQuery('body').on('click', '.subscribepopup', function(e) {   
      e.preventDefault();
      jQuery('#subscriptionpopup').modal()
  });

  $(document).on('click.modal', 'button[rel~="modal:close"], #subscriptionpopup button', $.modal.close);





  
  $('body').on('click', '.show_order_info', function(e) {   
    e.preventDefault();
    var self = $(this);
    if ($(this).text()=='cancel') {
      $(this).parent('.cart-attribute__field').find('.hiddeninput[type="textarea"]').val('');
      $(this).parent('.cart-attribute__field').find('.hiddeninput[type="input"]').val('');
    }
    $(this).parent('.cart-attribute__field').find('.hiddeninput').toggle(
      200,function(){
        if (self.text() == 'add' || self.text() == 'edit' ) {
          self.text('cancel');
        } else {
          self.text(self.data('text'));
        }
    });
  });


  
$(document).on('click.modal', 'button[rel~="modal:close"]', $.modal.close);
  
    if ($('[data-target="#faq-8bf20ecc-b8e5-4cf3-b774-98638cd99ad3"]').length > 0) {
        $('[data-target="#faq-8bf20ecc-b8e5-4cf3-b774-98638cd99ad3"]').click()
    }

    // FOOTER ACCORDION START	
    $('.footergroup').find('.accordion-toggle').click(function() {
        $(this).toggleClass("on");
        //Expand or collapse this panel
        $(this).next().slideToggle('fast');
        //Hide the other panels
        $(".accordion-content").not(jQuery(this).next()).slideUp('fast');
    });
    // FOOTER ACCORDION END
});

/*    
$("#ProductNav #options input").on("change",function(){
    var checker = $(this).is(':checked');
  console.log( checker );
  if (checker) {
    if ($(this).attr('id') == "viewall") {
      console.log("clicked viewall");
 // console.log($(this).attr('id'));
     $('#options .landingfilters').prop("checked", false);
     //$('#viewall').attr('checked','checked');
    } else {
      console.log("not clicked viewall");
       $('#viewall').prop("checked", false);
    } 
  }
 // console.log($(this).attr('id'));
 // var checkboxes = $('#options input[type=checkbox]:checked');
  //$.each(checkboxes, function () {
   //console.log($(this).attr('id'));
  //});
});
*/

$(document).ready(function () {
  var $sideColumn = $('#side-column');

  if (!$sideColumn.length) return;

  function showMobileBuilder() {
    $sideColumn.addClass('mobile-builder-visible');
  }

  if (window.matchMedia('(max-width: 767px)').matches) {
    var builderRevealTimer = setTimeout(showMobileBuilder, 2500);

    $(window).one('scroll.mobileBuilderReveal touchmove.mobileBuilderReveal', function () {
      clearTimeout(builderRevealTimer);
      showMobileBuilder();
    });
  }
});



// $(document).ready(function () {
//   if (!$('#sidebar-hint').length) return;
//   if ($(window).width() >= 768) {
//     setTimeout(function(){
//       // only show if user hasn't used sidebar
//       if (!$('#side-column').hasClass('hover')) {
//         $('#sidebar-hint').fadeIn(300);
//       }
//     },12000);
//     $('#side-column').one('mouseenter click', function(){
//       $('#sidebar-hint').fadeOut(300);
//     });
//   }
// });

$(document).ready(function () {
    if (!$('#sidebar-hint').length) return;
    if ($(window).width() < 768) return;

    // Already shown before?
    if (localStorage.getItem('sidebarHintShown')) return;

    setTimeout(function () {
        if (!$('#side-column').hasClass('hover')) {
            $('#sidebar-hint').fadeIn(300);

            // Mark as shown
            localStorage.setItem('sidebarHintShown', 'true');
        }
    }, 12000);

    $('#side-column').one('mouseenter click', function () {
        $('#sidebar-hint').fadeOut(300);
    });
});



$(document).ready(function() {




$("#side-column").mouseenter(function() {
    //$('body').toggleClass('stickbackground');
    $('body').addClass('stickbackground');
}).mouseleave(function() {
    jQuery('#side-column').scrollTop(0);
   // $('body').toggleClass('stickbackground');
    $('body').removeClass('stickbackground');
});

$('body').on('mouseleave', '#side-column.hover', function(e) {
        $("#side-column").animate({
            right: -260
        }, 200, "easeOutCirc", function() {
            $("#side-column").removeClass('hover');
            $("#side-column").removeClass('is-open');
            $("#side-column").removeAttr("style");
        });
    });



  
	 //basket work to top right
    $('body').on('click', '.js-mini-cart', function(e) {
        $("#cart_message").text('');
    });
	
	$('body').on('click', '.close_minibasket', function(e) {
        $(".js-mini-cart").removeClass('active');
      $('body, html').removeClass('locked');
    });
	
	$('#side_bar_modal').click(function(e) {
$("#side-column").animate({
            right: -260
        }, 200, "easeOutCirc", function() {
            $("#side-column").removeClass('hover');
            $("#side-column").removeClass('is-open');
            $("#side-column").removeAttr("style");
        });
      
    });
	

    $('#options h3').click(function(e) {
        var openfilter = $(this).next('.option-set');
        //openfilter.addClass('open');
        openfilter.toggleClass('open');
        $(this).toggleClass('active');
    });


    $('#open_filter').click(function(e) {
        e.preventDefault();
        //  $('#filter_menu').css({left:0});
        $('#filter_menu').addClass('open');
    });



    $('.close_filter').click(function(e) {
        e.preventDefault();
        $('#filter_menu').removeClass('open');
    });

    $('a.findoutmore').click(function(e) {
        e.preventDefault();
        $(this).modal({
            fadeDuration: 60
        });
        return false;
    });

  var alertcount = 0;

    function addobasketcondition() {
        if ($('#box').attr('data-count') > 1) {
            //$('button.product-form__submit').removeAttr("disabled");
        } else {
            //$('button.product-form__submit').attr('disabled', true);
        }
    }


//  var intervalID;
//   start();
//     function start(){
//         intervalID = setInterval(activateNudge, 60000);
//     }

//     // Function to stop setInterval call
//     function stop(){
//         clearInterval(intervalID);
//     }


// function activateNudge() {
//   var allowpopup = true;
//   if ($.session.get('a2bNudge')) {
//     allowpopup = false;
//   }

  
//   //console.log('active nudge');
//     if ($('#box').attr('data-count') > 1 && allowpopup) {

//       var variantstoadd = '';
//   $("#box > a .slot.selected").each(function() {
//     variantstoadd += ( $(this).data('variant-title') + ', ' );
//   });
//   $('#nudgevariants').text(variantstoadd.slice(0,-2));
//   $('#a2bNudge').modal();
//        $.session.set('a2bNudge', 'activated');
//     }
//   stop();
// }
  

    $.fn.addToSlot = function(id, title, color, image) {
      var boxItemParent = $('#box').find('.empty-slot:first');  
      boxItemParent.html('<div class="slot empty"></div>');
      var boxItem = $('#box').find('.slot.empty:first');
        //boxItem.parent('a').html('<div class="slot empty"></div>');
        boxItem.parent('a').removeClass('empty-slot');
        $(boxItem).attr({
            'data-variant-id': id,
            'data-variant-title': title
        });
        $(boxItem).after("<span>"+title+"</span>");
        $('<span class="remove" href="#"></span>').insertBefore('.slot.empty:first');
        $(boxItem).removeClass('empty');
        $(boxItem).addClass('selected');
        $('#' + id).addClass('active');
        $('#popup_' + id).addClass('active');
        console.log('adding to boxitem');
        console.log(color + ' - ' + image);
        // $(boxItem).css({
        //     'background-color': color,
        //     'border-color': color,
        //     'background-image': 'url('+image+')'
        // });
        $(boxItem).css({
            'background-image': 'url('+image+')'
        });
        
        $('#box, #mobilecounter').attr('data-count', parseInt($('#box').attr('data-count')) + 1);
        $('#selection-counter').html($('#box').attr('data-count'));
        //addobasketcondition();
      // stop();
      // start(); 
    }



    if ($.session.get('slotArray')) {
        //var essenceArray =  $.session.get('slotArray').split(',');
        var bottle = JSON.parse($.session.get('slotArray'));
        var product = {};
        $.each(bottle, function(i, value) {
            //  var essenceStored = $('#' + value);
            $.fn.addToSlot(value['id'], value['title'], value['color'], value['image']);
        });
    } else {
        //  var essenceArray = [];
        var bottle = [];
        var product = {};
    }


    /*$('#addobasketpopup').on($.modal.AFTER_CLOSE, function (event, modal) {
        //location.reload();
        });*/

        var heightbox = $('#AddToCartForm').height() + 65;
    $('body').on('mouseleave', '#side-column.hover', function(e) {
        $("#side-column").animate({
            right: -260
        }, 200, "easeOutCirc", function() {
            $("#side-column").removeClass('hover');
            $("#side-column").removeClass('is-open');
            $("#side-column").removeAttr("style");
        });
    });

//     $('body').on('click', '#side-column', function(e) {
// if(e.target != this) return;


//        $('#side-column').removeAttr('style');
//        $('#side-column').removeClass('is-open');
//         $("#side-column").toggleClass('hover');
//         $('html').toggleClass('stickscroll');
        

//       if ( $(window).width() < 767 && $('#side-column').hasClass('hover') ) {
//        //   var heightbox = $('#AddToCartForm').height() + 65; //105
//        // console.log(heightbox);
//        //$('#side-column #AddToCartForm').toggleClass('scrollbox');
//       // $('html').css('overflow', 'hidden');
//        // $('#side-column').css('max-height',heightbox);
//       //  $('#side-column').css('height','calc(90vh - 60px)');
//         $('#side-column').css('height','auto');
//       }
//     });


$('body').off('click', '#box').on('click', '#box', function(e) {
  if ($(e.target).closest('a.empty-slot').length) return;

  var $col = $('#side-column');
  var nowOpen = !$col.hasClass('is-open');

  $col.toggleClass('is-open', nowOpen);
  $('html').toggleClass('stickscroll', nowOpen);
  $('body').toggleClass('stickbackground', nowOpen);

  return false;
});

// $('body').off('click', '.exploreessences').on('click', '.exploreessences', function(e) {
//   e.preventDefault();
//   e.stopPropagation();
//   window.location.href = $(this).attr('href');
// });

// $(document).off('click.sidecolumn').on('click.sidecolumn', function(e) {
//   var $col = $('#side-column');
//   if (!$col.hasClass('is-open')) return;
//   if ($(e.target).closest('#side-column').length) return;

//   $col.removeClass('is-open');
//   $('html').removeClass('stickscroll');
//   $('body').removeClass('stickbackground');
// });



$('body').on('click', '#side-column', function(e) {
  if (e.target !== this) return; // only true for clicks landing on the ::before bar

  var $col = $(this);
  var nowOpen = !$col.hasClass('is-open');

  $col.toggleClass('is-open', nowOpen);
  $('html').toggleClass('stickscroll', nowOpen);
  $('body').toggleClass('stickbackground', nowOpen);
});

  
    $('body').on('click', '#essences_list button.active, #essences_grid button.active', function(e) {

      console.log('add to basket 1');
        if ($(window).width() < 767) {
            var slot_delete = $('.slot.selected[data-variant-id="' + $(this).data('variant-id') + '"]')
            var slotID = $(this).data('variant-id');
            $('#' + slotID).removeClass('active');
            $('#popup_' + slotID).removeClass('active');
            slot_delete.prev('.remove').remove();
            slot_delete.remove();
            $('#box').append('<div class="slot empty"></div><span class="addanessence"><!--Add an essence--></span><span class="startyourremedy"><!--start your remedy--></span>');
            $('#box').attr('data-count', parseInt($('#box').attr('data-count')) - 1);
            $('#selection-counter').html($('#box').attr('data-count'));
            //addobasketcondition();
            var index = bottle.findIndex(item => item.id == slotID);
            bottle.splice(index, 1);
            $.session.set('slotArray', JSON.stringify(bottle));
            //  essenceArray.splice($(this).attr('data-variant-id'),1);
            //   $.session.set( 'slotArray',essenceArray );
            e.preventDefault();
        }
    });



  
$('body').on('click', '.reviewhighlight a', function(e) {
  e.preventDefault();
$("html").animate({
            scrollTop: $("#review").offset().top - 80
        }, 400);
});



  const essenceObj = {
     A1: {
        id: 42064315613413,
        title: "Agrimony",
        colour: "#e5e3d3",
     },
     A2: {
        id: 42064315678949,
        title: "Aspen",
        colour: "#eaf0ee",
     },
     B1: {
        id: 42064315711717,
        title: "Beech",
        colour: "#fbf1ec",
     },  
     C1: {
        id: 42064315744485,
        title: "Centaury",
        colour: "#e5e3d3",
     },
     C2: {
        id: 42064315777253,
        title: "Cerato",
        colour: "#f6e1e7",
     },
     C3: {
        id: 42064315810021,
        title: "Cherry Plum",
        colour: "#dbdfe0",
     },
     C4: {
        id: 42064315842789,
        title: "Chestnut Bud",
        colour: "#e3e6e5",
     },
     C5: {
        id: 42064315875557,
        title: "Chicory",
        colour: "#f7ecee",
     },
     C6: {
        id: 42064315908325,
        title: "Clematis",
        colour: "#f7ecee",
     },
     C7: {
        id: 42064315941093,
        title: "Crab Apple",
        colour: "#faead8",
     },
     E1: {
        id: 42064315973861,
        title: "Elm",
        colour: "#e5e3d3",
     },
     G1: {
        id: 42064316006629,
        title: "Gentian",
        colour: "#f6e1e7",
     },
     G2: {
        id: 42064316039397,
        title: "Gorse",
        colour: "#fbf1ec",
     },
     H1: {
        id: 42064316072165,
        title: "Heather",
        colour: "#dbdfe0",
     },
     H2: {
        id: 42064316104933,
        title: "Holly",
        colour: "#fbf1ec",
     },
     H3: {
        id: 42064316137701,
        title: "Honeysuckle",
        colour: "#e3e6e5",
     },
     H4: {
        id: 42064316170469,
        title: "Hornbeam",
        colour: "#dbdfe0",
     },
     I1: {
        id: 42064316268773,
        title: "Impatiens",
        colour: "#f8e2d8",
     },
     L1: {
        id: 42064316367077,
        title: "Larch",
        colour: "#faead8",
     },
     M1: {
        id: 42064316465381,
        title: "Mimulus",
        colour: "#fbf1ec",
     },
     M2: {
        id: 42064316563685,
        title: "Mustard",
        colour: "#e3e6e5",
     },
     O1: {
        id: 42064316661989,
        title: "Oak",
        colour: "#dbdfe0",
     },
     O2: {
        id: 42064316694757,
        title: "Olive",
        colour: "#e5e3d3",
     },
     P1: {
        id: 42064316727525,
        title: "Pine",
        colour: "#f7ecee",
     },
     R1: {
        id: 42064316760293,
        title: "Red Chestnut",
        colour: "#f7ecee",
     },
     R2: {
        id: 42064316793061,
        title: "Rock Rose",
        colour: "#e3e6e5",
     },
     R3: {
        id: 42064316825829,
        title: "Rock Water",
        colour: "#fbf1ec",
     },
     S1: {
        id: 42064316858597,
        title: "Scleranthus",
        colour: "#dbdfe0",
     },
     S2: {
        id: 42064316891365,
        title: "Star of Bethlehem",
        colour: "#eaf0ee",
     },
     S3: {
        id: 42064316924133,
        title: "Sweet Chestnut",
        colour: "#fbf1ec",
     },
     V1: {
        id: 42064316956901,
        title: "Vervain",
        colour: "#f7ecee",
     },
     V2: {
        id: 42064316989669,
        title: "Vine",
        colour: "#faead8",
     },
     W1: {
        id: 42064317022437,
        title: "Walnut",
        colour: "#d8dad6",
     },
     W2: {
        id: 42064317055205,
        title: "Water Violet",
        colour: "#f7ecee",
     },
     W3: {
        id: 42064317087973,
        title: "White Chestnut",
        colour: "#e5e3d3",
     },
     W4: {
        id: 42064317120741,
        title: "Wild Oat",
        colour: "#eae6dd",
     },
     W5: {
        id: 42064317153509,
        title: "Wild Rose",
        colour: "#f7ecee",
     },
     W6: {
        id: 42064317186277,
        title: "Willow",
        colour: "#fbf1ec",
     },
  };  

$('body').on('click', '.custom-add', function(e) {
  e.preventDefault();

  var selectVariants = $(this).data('variants');
  var selectVariantsArray = selectVariants.split(",");
  var customVariantCount = selectVariantsArray.length;
  var sessionTest = 'empty';
     if ($.session.get('slotArray')) {
        sessionTest = $.session.get('slotArray');
     }
    var alertCount = 0;
     var uniqueTest = false;
  $(selectVariantsArray).each(function (i, val) {
     // let testID = essenceObj[val].id;
    if (sessionTest.indexOf( essenceObj[val].id) >= 0) {
      if (alertCount == 0) {
       alert('You’ve added the same remedy twice. Please re-select or add to basket.');
      }
      alertCount = alertCount + 1;
    } else {
       uniqueTest = true;
    addToSidebar( essenceObj[val].id, essenceObj[val].title, essenceObj[val].colour, essenceObj[val].image );
    }
  });
  if (uniqueTest) {
  slideSideBar(customVariantCount);
  }
});



$('body').on("click", ".amendsubscription", function(e) {
$(this).parent('.item-selling-plan').hide();
$(this).parent('.item-selling-plan').parent('.lineitems').find('.subscriptionselectwrapper').show();
e.preventDefault();
});

  
      $('body').on("click", ".cancelsubscriptionchange", function(e) {
     $(this).parent('.subscriptionselectwrapper').hide();
$(this).parent('.subscriptionselectwrapper').parent('.lineitems').find('.item-selling-plan').show();
        e.preventDefault();
    });


 $('body').on("change", ".cart-selling-plan", function(e) {
   var selling_plan = $(this).val();
   //if  (selling_plan == '') {
     //selling_plan = null;
   //}
     
      $.ajax({
        url: "/cart/change.js",
        type: "POST",
        data: '{"id":"'+$(this).data('item-key')+'", "quantity": '+$(this).data('quantity')+', "selling_plan": '+selling_plan+' }', 
        contentType: "application/json",
        dataType: 'json',
        success: function(result){
      location.reload();
    }
    });
   
        e.preventDefault();
    });


  
  /*
  
    $('body').on("change", ".cart-selling-plan", function(e) {

console.log( $(this).val() );
console.log( $(this).data('item-key') );
console.log( $(this).data('line') );
console.log( $(this).data('quantity') );
      console.log(         $(this).find('option:selected').text().trim());
      $.ajax({
        url: "/cart/change.js",
        type: "POST",
        data: '{"id":"'+$(this).data('item-key')+'", "quantity": '+$(this).data('quantity')+', "selling_plan": '+$(this).val() +' }', 
        contentType: "application/json",
        dataType: 'json'
    });
    //  location.reload();
  //    $(this).parent('.subscriptionselectwrapper').parent('.lineitems').find('.item-selling-plan').find('em').text( $(this).find('option:selected').text().trim());
  //   $(this).parent('.subscriptionselectwrapper').hide();
//$(this).parent('.subscriptionselectwrapper').parent('.lineitems').find('.item-selling-plan').show();
        e.preventDefault();
       // 42064315580645  7447390224613     data: '{"id":"'+$(this).data('product-id')+'", "quantity": 1, "selling_plan": '+$(this).val()+' }', 
    });
*/

  


  

$('body').on('click', '#essences_list button:not(.active), .full_description button:not(.active), #essences_grid button:not(.active)', function(e) {
$('#sidebar-hint').hide();

        console.log('add to basket 2');
console.log('test'+$(this).attr('data-image'));
e.preventDefault();
  addToSidebar( $(this).attr('data-variant-id'), $(this).attr('data-variant-title'), $(this).attr('data-color-code'), $(this).attr('data-image') );
  slideSideBar(0);
});

 $('#completemyremedy').on('click', function (e) {
$('#side-column #box').addClass('step3showing');
    e.preventDefault();
$('#side-column #step2').hide();
$('#side-column #step3').show();
$('#side-column #box span').hide();
})

$('#gobacktostep2, #gobacktostep2mobile').on('click', function (e) {
$('#side-column #step2').show();
$('#side-column #box').removeClass('step3showing');
 e.preventDefault();
$('#side-column #box span').show();
$('#side-column #step3').hide();

});


/*
$('body').on('click', 'h1', function(e) {
  var variantstoadd = '';
  $("#box > a .slot.selected").each(function() {
    variantstoadd += ( $(this).data('variant-title') + ', ' );
  });
  $('#nudgevariants').text(variantstoadd.slice(0,-2));
  $('#a2bNudge').modal();
});

  
 $('#a2bNudge').on('click', 'button', function(e) {
   $("#AddToCartForm.buildabox").submit()
 });
*/

//    $('#a2bNudge').on('click', 'button', function(e) {
//    $("#AddToCartForm.buildabox").submit()
//  });

//setInterval(activateNudge, 20000);




  


//setInterval(bounceActiveSideBar, 2000);
  /*
  function bounceActiveSideBar() {
  var target = $("#side-column");
  var positionTest = $('body').outerWidth() - target.position().left + target.outerWidth();
    if ($('#box').attr('data-count') > 2 && positionTest < 361) {
    $("#side-column").addClass("bounce");
    $("#side-column").effect( "bounce", {direction:'left', distance: 80, times: 3}, 200 );
            setTimeout(function() {         
    $("#side-column").removeClass("bounce");
    }, 1000);
  }

}*/
  

function addToSidebar(idVar, titleVar, colourVar, imageVar) {
  console.log('add to sidebar'+imageVar);
  var addtosidebartrue = true;
for (let key in bottle) {
    if (bottle[key].id === idVar) {
      addtosidebartrue = false;
        break; // Exit the loop once found
    }
} 

  if (addtosidebartrue) {
   if ($('#box').attr('data-count') < 7 ) {


    
      $.fn.addToSlot(idVar, titleVar, colourVar, imageVar);
      //   essenceArray.push( $(this).attr('data-variant-id') );
      product.id = idVar;
      product.color = colourVar;
      product.title = titleVar;
      product.image = imageVar;
      bottle.push({
         id: product.id,
         title: product.title,
         color: product.color,
         image: product.image
      });
      //bottle[bottle] = bottle[$(this).attr('data-variant-title')];
      //bottle.push({product});
      //bottle[$('#box').attr('data-count')] = product;
      //var num = $('#box').attr('data-count') - 1;
      //Object.assign(bottle, { num : product});
      $.session.set("price", $('#hiddenboxPRICE').val());
      $.session.set("id", $('#hiddenboxID').val());
      //  $.session.set( 'slotArray',essenceArray );
      $.session.set('slotArray', JSON.stringify(bottle));
   } else {
    if ( alertcount == 0) {
      alert('Please remove an essence before adding another one.');
        alertcount = alertcount + 1;
     }
   }
  }
}

/*
  function slideSideBar(customVariantCount) {

   if ($('#box').attr('data-count') == 7 || customVariantCount > 1) {
      $('#side-column').removeAttr('style');
      $("#side-column").addClass('hover');
      $('html').toggleClass('stickscroll');
      if ($(window).width() < 767 && $('#side-column').hasClass('hover')) {
         //var heightbox = $('#AddToCartForm').height() + 105;
        var heightbox = $('#AddToCartForm').height();
         $('#side-column').css('height', 'auto');
         //$('#side-column').css('height', heightbox);
      }
      $("#side-column").animate({
         right: 40
      }, 200, "easeOutQuad", function() {
      });
   } else {
      $('#side-column').removeAttr('style');
      $("#side-column").addClass('hover');
      $('html').toggleClass('stickscroll');
      if ($(window).width() < 767 && $('#side-column').hasClass('hover')) {
         //var heightbox = $('#AddToCartForm').height() + 105;
         var heightbox = $('#AddToCartForm').height();
         $('#side-column').css('height', 'auto');
      }
      $("#side-column").animate({
         right: 40
      }, 200, "easeOutQuad", function() {

         setTimeout(
            function() {
               $("#side-column").animate({
                  right: -260
               }, 200, "easeOutCirc", function() {
                  $("#side-column").removeClass('hover');
                  $('html').toggleClass('stickscroll');
                 if ($(window).width() >= 767) {
                  $("#side-column").removeAttr("style");
               }
               });
            },
            900);
            
      });
   }
    
  }*/




function slideSideBar(customVariantCount) {
$('#side-column').addClass('mobile-builder-visible');
    var shouldStayOpen = ($('#box').attr('data-count') == 7 || customVariantCount > 1);

    $('#side-column').removeAttr('style');
    $('#side-column').removeClass('is-open');
    $('#side-column').addClass('hover is-open');
    $('html').addClass('stickscroll');
    if ($(window).width() < 767 && $('#side-column').hasClass('hover')) {
        $('#side-column').css('height', 'auto');
    }
    if (!shouldStayOpen) {
        setTimeout(function () {
            $('#side-column').removeClass('is-open');

            setTimeout(function () {
                $('#side-column').removeClass('hover');
                $("#side-column").removeClass('is-open');
                $('html').removeClass('stickscroll');

                if ($(window).width() >= 767) {
                    $('#side-column').removeAttr('style');
                }
            }, 400); // matches CSS transition time
        }, 1500);
    }
}



  


function getQuizParameters() {
        var parameters = {},
            hash;
        var q = document.URL.split('?')[1];
        if (q != undefined) {
            q = q.split('&');
            for (var i = 0; i < q.length; i++) {
                hash = q[i].split('=');
                parameters[hash[0]] = hash[1];
            }
        }
        return parameters;
    }
    $(document).ready(function() {
        var parameters = getQuizParameters();
        if (parameters['essenceaddtosidebar'] == 'yes') {
            $.each(parameters, function(key, value) {
              //  if (key.includes("prodId")) {
               if (key =="prodId") {   
                var essenceValue = essenceObj[value].id;             
                    //$.fn.addToSlot($('#' + essenceValue).attr('data-variant-id'), $('#' + essenceValue).attr('data-variant-title'), $('#' + essenceValue).attr('data-color-code'));
                  addToSidebar($('#' + essenceValue).attr('data-variant-id'), $('#' + essenceValue).attr('data-variant-title'), $('#' + essenceValue).attr('data-color-code'), $('#' + essenceValue).attr('data-image'));
                }
              //if (key.includes("prodIds")) {
              if (key == "prodIds") {
                const productarray = value.split(',');
                $.each(productarray, function( index, value ) {
                   var essenceValue = essenceObj[value].id;  
                  addToSidebar($('#' + essenceValue).attr('data-variant-id'), $('#' + essenceValue).attr('data-variant-title'), $('#' + essenceValue).attr('data-color-code'), $('#' + essenceValue).attr('data-image'));
                });
              }
            });
        }
    });





    /*function isEmpty(obj) {
      for(var key in obj) {
        console.log(key);
        if(obj.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    }*/


/*	function miniBasketFunction() {
		var miniCart = '.js-mini-cart';
		$btnCheckout = $('.js-cart-btn-checkout');
      $('.js-mini-cart-content').removeClass('emptycart');
		var styleCart = $(miniCart).attr("data-cartmini");
		//var cartToggle = '.js-toggle-cart';
		var cartCount = '.js-cart-count';
		var cartContent = '.js-mini-cart-content';
		var cartTotal = '.js-cart-total';
		var numberDisplayed = 5;
		Shopify.getCart(function(cart) {
			if (cart.item_count === 0) {
				$(cartContent).html(emptyCartHTML);
				$btnCheckout.addClass('disabled');
				styleCart === 'true' ? $(miniCart).removeClass('active') : null;

			} else {
				$btnCheckout.removeClass('disabled');
				//styleCart === 'true' ? $(miniCart).addClass('active') : null;
			}
			$(cartCount).text(cart.item_count);
			$(cartTotal).html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
			theme.freeShipping.load(cart);
			theme.updateCurrencies();
			var htmlCart = cart.item_count === 0 ? emptyCartHTML : '',
				itemCount = cart.items.length,
				forLoop = itemCount < numberDisplayed ? itemCount : numberDisplayed;
			//styleCart === 'true' ? cart.items.length ? $(miniCart).addClass('active'): $(miniCart).removeClass('active') :null;
			// add list items
			for (var i = 0; i < forLoop; i++) {
				var product = cart.items[i],
					productPrice = theme.Currency.formatMoney(product.price, theme.moneyFormat);
				product.title = product.title.split(' - ')[0];
				var pattern = /bottle/;
				var exists = pattern.test(product.sku);
				//if (product.sku == "sku_bottle_001") {
				//  if (exists) {
				//  product.title = "personalised remedy";
				//}
                htmlCart += '<div class="xx mini-cart-item">';
                htmlCart += '	<a class="mini-cart-image" href="'+ product.url +'">';
                htmlCart += '		<img src="'+ product.image +'"/>';
                htmlCart += '	</a>';
                htmlCart += '	<div class="mini-cart-meta">';
                htmlCart += '		<p ><a href="'+ product.url +'">'+ product.title +'</a></p>';
                //if (product.sku == "sku_bottle_001") {
                if (exists) {
                htmlCart += '		<dd>'+ product.properties.Essences +'</dd>';
                }
                //htmlCart += '		<span> '+ productPrice +'</span><b> x '+product.quantity+'</b>';
                htmlCart += '		<span> '+ productPrice +'</span>';
                htmlCart += '		<div class="quantity-section">';
                htmlCart += '		<button class="decrease-quantity" data-quantity="'+product.quantity+'" data-line="'+ (i+1) +'" data-id="'+product.id+'">-</button>';
                htmlCart += '		<b id="product_quantity_'+ (i+1) +'">'+product.quantity+'</b>';
                htmlCart += '		<button class="increase-quantity" data-quantity="'+product.quantity+'" data-line="'+ (i+1) +'" data-id="'+product.id+'">+</button>';
                htmlCart += '		</div>';
                htmlCart += '	</div>';
                //htmlCart += '	<button class="btn js-remove-mini-cart" data-id="'+product.id+'">&times;</button>';
                htmlCart += '	<button class="btn js-remove-mini-cart" data-line="'+ (i+1) +'" data-id="'+product.id+'">&times;</button>';
                htmlCart += '</div>';
              }
              if (itemCount > numberDisplayed){
                htmlCart += '<a class="js-btn-viewmore" href="/cart">'+theme.strings.cartMore+'('+(itemCount - numberDisplayed)+')</a>'
              }
              // add total price and cart button / checkout button
              $(cartContent).html(htmlCart);
              $(cartTotal).html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
              theme.updateCurrencies();
		})
		//$(miniCart).addClass('active');		
	}
*/



    $('body').on("click", ".remove", function(e) {
      console.log('remove clicked');
      alertcount = 0;
        //$(this).append('<div class="slot empty"></div>');
        var addinempty = $(this).parent('a');
        var slot_delete = $(this).next(".selected");
        var span_delete = $(this).next(".selected").next("span");
        var slotID = slot_delete.data('variant-id');
        $('#' + slotID).removeClass('active');
        $('#popup_' + slotID).removeClass('active');
        slot_delete.remove();
        span_delete.remove();
        $(this).remove();
        
        //$('#box').append('<div class="slot empty"></div>');
        addinempty.html('<div class="slot empty"></div><span class="addanessence"><!--Add an essence--></span><span class="startyourremedy"><!--start your remedy--></span>');
        addinempty.addClass('empty-slot');
        $('#box').attr('data-count', parseInt($('#box').attr('data-count')) - 1);
        $('#selection-counter').html($('#box').attr('data-count'));

        console.log(parseInt($('#box').attr('data-count')));
        if (parseInt($('#box').attr('data-count')) == 6) {
          $('#box .empty-slot').appendTo('#box');
        }
        addobasketcondition();
        var index = bottle.findIndex(item => item.id == slotID);
        bottle.splice(index, 1);
        $.session.set('slotArray', JSON.stringify(bottle));
        //  essenceArray.splice($(this).attr('data-variant-id'),1);
        //   $.session.set( 'slotArray',essenceArray );
        e.preventDefault();
    });








    // Add to basket start
    $('#AddToCartForm.buildabox').submit(function(e) {

  //    $('#side-column').hide();

        var choosenBase = $('#choose-your-base option:selected').val();
        var choosenFrequency = '';
        if ($('#SubscribeSave').is(":checked")) {
         choosenFrequency = $('#frequencyselection option:selected').val();
        }
      
        if ($('#box .slot.selected').length > 1) {
            var variantsToAdd = {};
            var boxChoices = [];
            // var boxPrice = $('#box').data('price') / 100;
            var boxPrice = $.session.get('price') / 100;
            $("#box .slot.selected").each(function() {
                var essence = $(this).attr('data-variant-title');
                var essenceId = parseInt($(this).attr('data-variant-id'));
                if (variantsToAdd[essenceId] != null) {
                    variantsToAdd[essenceId] = parseInt(variantsToAdd[essenceId]) + 1;
                    boxChoices[essence] = boxChoices[essence] + 1;
                    $.each(boxChoices, function(i, value) {
                        if (boxChoices[i].title == essence) {
                            boxChoices[i].quantity = boxChoices[i].quantity + 1;
                        }
                    });
                } else {
                    variantsToAdd[essenceId] = 1;
                    boxChoices[essence] = 1;
                    boxChoices.push({
                        id: essenceId,
                        title: essence,
                        quantity: 1
                    });
                }
            });
            var essenceString = '';
            $.each(boxChoices, function(i, value) {
                boxChoices[i].quantity = boxChoices[i].quantity / 1;
                //essenceString = essenceString + boxChoices[i].quantity + ' x ' + boxChoices[i].title + ', ';
                essenceString = essenceString + boxChoices[i].title + ', ';
            });
            essenceString = essenceString.replace(/,\s*$/, "");
            Shopify.queue = []; // Define the empty queue
            Shopify.queue.push({
                //  variantId: $('#box').attr('data-variant-id')
                variantId: $.session.get('id'),
                quantity: 1,
                properties: {
                    Size: 1,
                    Essences: essenceString,
                    Price: '£' + boxPrice.toFixed(2)
                }
            });
            Shopify.moveAlong = function() {
                if (Shopify.queue.length) {
                    var request = Shopify.queue.shift();
                    var data = {};
                    if (request.properties) {
                        data = {
                            id: request.variantId,
                            quantity: request.quantity,
                            selling_plan: choosenFrequency,
                            properties: {
                                Essences: essenceString,
                                Price: '£' + boxPrice.toFixed(2),
                                'Base': choosenBase
                            }
                        };
                    } else {
                        data = {
                            id: request.variantId,
                            quantity: request.quantity
                        };
                    }
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        dataType: 'json',
                        data: data,
                        success: function(response) {
                            Shopify.moveAlong();
                          $.session.remove('a2bNudge');
                            $.session.remove('slotArray');
                            $.each($('#box .slot.selected '), function(i, value) {
                                $('#' + $(this).data('variant-id')).removeClass('active');
                                $('#popup_' + $(this).data('variant-id')).removeClass('active');
                                $(this).remove();
                                $('.remove').remove();
                               // $('#box').append('<div class="slot empty"></div><span class="addanessence">Add an essence</span><span class="startyourremedy">start your remedy</span>');
                               // $('#box').attr('data-count', 0);
                            });
                            $('#basket_items').html(essenceString);
                             $('#side-column').off('hover');
                            /*$('#side-column').off('mouseenter mouseleave');
                            $("#side-column").css("right", -260);
                            $("#side-column").removeClass('hover');
							miniBasketFunction();
                            setTimeout(function() {
                                $("#side-column").removeAttr("style");
                            }, 800);
                            //alert('added to basket');*/
                          
                          location.href='/cart';

                          /*
                          //commented out below as added location to cart instead of a popup
                          $('#addobasketpopup').modal();
                          miniBasketFunction();
                          $("#side-column").css('right',-260);
                          $("#side-column").removeClass('hover');
                            //location.reload();
                            */
                        },
                        error: function(response) {
                            alert(response.responseJSON.description); // Show error in dialog
                            if (Shopify.queue.length) {
                                Shopify.moveAlong();
                            }
                        }
                    });
                }
            };
            Shopify.moveAlong();
        }
        else {
            alert('Please select a minimum of 2 essences before adding to the cart.');

        }
        e.preventDefault();
    });
    // Add to basket end
});




// $(document).ready(function() {
	
//     /*jshint browser:true, undef: true, unused: true, jquery: true */
//     // store filter per group
//     var filters = {};
//     var $container = $('#essences_list');
//     var $filterDisplay = $('#filter-display');
//     $container.isotope();
//     // do stuff when checkbox change
//     $('#options').on('change', function(event) {
//         var checkbox = event.target;
//         var $checkbox = $(checkbox);
//         var group = $checkbox.parents('.option-set').attr('data-group');
//         // create array for filter group, if not there yet
//         var filterGroup = filters[group];
//         if (!filterGroup) {
//             filterGroup = filters[group] = [];
//         }
//         // add/remove filter
//         if (checkbox.checked) {
//             // add filter
//             filterGroup.push(checkbox.value);
//         } else {
//             // remove filter
//             var index = filterGroup.indexOf(checkbox.value);
//             filterGroup.splice(index, 1);
//         }
//         var comboFilter = getComboFilter();
//         $container.isotope({
//             filter: comboFilter
//         });
//         $filterDisplay.text(comboFilter);
//     });



//     function getComboFilter() {
//         var combo = [];
//         for (var prop in filters) {
//             var group = filters[prop];
//             if (!group.length) {
//                 // no filters in group, carry on
//                 continue;
//             }
//             // add first group
//             if (!combo.length) {
//                 combo = group.slice(0);
//                 continue;
//             }
//             // add additional groups
//             var nextCombo = [];
//             // split group into combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
//             for (var i = 0; i < combo.length; i++) {
//                 for (var j = 0; j < group.length; j++) {
//                     var item = combo[i] + group[j];
//                     nextCombo.push(item);
//                 }
//             }
//             combo = nextCombo;
//         }
//         var comboFilter = combo.join(', ');
//         return comboFilter;
//     }
//     // helper made to make items
// });

// Slick

$(document).ready(function() {
    $('.why-choose-inner-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });

});

$(document).ready(function() {
    $('.usp-inner-container-mob').slick({
        rows: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
    });
});

$(document).ready(function() {
    $('.review-70-ppc-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });
});


$(document).ready(function() {
    var apnd = '<div class="review-head-cont"><div class="review-title">refer a friend.</div><div class="review-head-p"><div class="review-subline"><p>Refer a friend to Mindful Remedies and if they make a purchase both you and your friend will receive a discount!<p></div></div></div>';
    $('.referral #MainContent').prepend(apnd);
});


$(document).ready(function() {
    var apnd = '<div class="review-head-cont"><div class="review-title">our happy customers.</div><div class="review-head-p"><div class="review-subline">we would love to hear from you!<p>Simply leave a review below and you\'ll receive<br/> a <strong>15% discount</strong> code to use on your next order.</p></div><div class="review-head-img"><img src="https://cdn.shopify.com/s/files/1/0601/5313/5333/files/review-header-img.png?v=1638118566"></div></div></div>';
    $('.reviews #MainContent').prepend(apnd);
});


$(document).ready(function() {
    var apnd = '<div class="review-head-cont"><div class="review-title">Share a review.</div><div class="review-head-p"><div class="review-subline">we would love to hear from you!<p>Simply leave a review below and you\'ll receive<br/> a <strong>15% discount</strong> code to use on your next order.</p></div><div class="review-head-img"><img src="https://cdn.shopify.com/s/files/1/0601/5313/5333/files/review-header-img.png?v=1638118566"></div></div></div>';
    $('.share-review #MainContent').prepend(apnd);
});


$(document).ready(function() {
    var checkExist = setInterval(function() {
        if ($('.ssw-carousel-review__text').length) {
            $("a[href='https://mindfulremedies.co.uk/products/personalised-remedy']").prop('href', 'https://mindfulremedies.co.uk/pages/reviews');
            clearInterval(checkExist);
        }
    }, 500);
});


$(document).ready(function() {
    function giftClick() {
        $("#ymq-attrib-ymq-variant-0-0").click(function() {
            $(".product-single__price").text("£24.00");
        });
        $("#ymq-attrib-ymq-variant-0-1").click(function() {
            $(".product-single__price").text("£49.00");
        });
    }
    setTimeout(giftClick, 1000)
});






jQuery('body').on('change', '.shopify_subscriptions_app_block_purchase_options .shopify_subscriptions_app_block_label input', function() {
  /*
  jQuery('.shopify_subscriptions_app_block_label_children label').each(function () {
    var t = $(this).html();
    t = t.replace(', 5% off', '');
    $(this).html(t);
 });
*/
  if(jQuery('.shopify_subscriptions_app_block_purchase_options input[data-radio-type="selling_plan_group"]').is(':checked')) {
    console.log('this is checked');
    jQuery('.shopify_subscriptions_app_block_label_children').fadeIn();
  } else {
    jQuery('.shopify_subscriptions_app_block_label_children').fadeOut();
    console.log('this is not checked');
  }

  });





/* REVIEWS */
(() => {
  const css = `

  .gw-text--heading-lg {background:#fff !important;border-top-left-radius: 30px;border-top-right-radius: 30px;padding-left:20px;box-sizing:border-box;padding-top:20px;}

  @media (min-width:768px) {
  .reviews-general-theme .reviews-general-theme {padding:20px 40px;box-sizing:border-box;}
  .gw-text--heading-lg {background:#fff !important;padding: 40px 40px 0px 40px;border-top-left-radius: 30px;border-top-right-radius: 30px;}
}
.gw-text--heading-lg + div {margin-top: -20px;background:#fff !important; padding: 20px 40px 0px 40px;}
  .gw-rv-page-widget__images-slider-wrapper {background:#fff !important; padding: 20px 40px 30px 40px;border-bottom-left-radius: 30px;border-bottom-right-radius: 30px;margin-top: -20px;}
   .gw-rv-page-widget__tabs { background:#fff !important; border-radius:30px;padding:20px 40px 20px 40px;box-sizing: border-box;}
 .gw-rv-reviews-list-widget { background:#fff !important; border-radius:30px;box-sizing: border-box;padding:0 10px;}
  .gw-tabs.gw-rv-product-page-widget__tabs.svelte-1peawzs {margin-top:20px;}
   .gw-rv-product-page-widget__images-slider-wrapper {background:#fff !important; padding: 20px 40px 30px 40px;border-bottom-left-radius: 30px;border-bottom-right-radius: 30px;margin-bottom: 20px;}
   .gw-text--heading-lg + div {padding: 20px 40px 40px 40px;border-bottom-left-radius: 30px;border-bottom-right-radius: 30px;}
 .gw-rv-product-page-widget__images-slider-wrapper {border-radius: 30px;padding-top: 30px;margin: 0px 0 35px 0px;}
    `;
  




  const inject = (sr) => {
    if (sr.querySelector('style[data-gw]')) return true;
    const s = document.createElement('style');
    s.dataset.gw = "1";
    s.textContent = css;
    sr.appendChild(s);
    return true;
  };

  const tryOnce = () => {
    for (const el of document.querySelectorAll('*')) {
      const sr = el.shadowRoot;
      if (sr && sr.querySelector('.gw-text, .gw-rv-page-widget__tabs')) {
        inject(sr);
        return true;
      }
    }
    return false;
  };

  let n = 0;
  const t = setInterval(() => {
    if (tryOnce() || ++n > 20) clearInterval(t);
  }, 250);
})();


